import * as organizationSelectors from './organizationSelectors';

export const getLoading = state => state.reportPage.loading;
export const getError = state => state.reportPage.error;
export const getData = state => state.reportPage.data;
export const getHeader = state => {
    const organization = organizationSelectors.getOrganization(state);
    if (!organization) {
        return [];
    }
    return [
        'Projects',
        ...organization.visibleInApplications.map(app => app.name),
    ];
};



// WEBPACK FOOTER //
// ./src/selectors/reportSelectors.js